import DownloadMobileApp from './styled';

export default DownloadMobileApp;
